import { apiDataManagerBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const daysApiRoutes = {
    list: apiDataManagerBaseURL + "days/",
    update: apiDataManagerBaseURL + "days/",
    delete: apiDataManagerBaseURL + "days/",
};

export class DayAPI {
    static list(calendars, fromDate, toDate, provider = '') {
        const url = `${daysApiRoutes.list}${calendars}/${fromDate}/${toDate}`;

        return API.authenticatedRequest({
            url: provider === '' ? url : `${url}?provider=${provider}`,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static update(id, day) {
        const url = `${daysApiRoutes.update}${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PUT,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(day)
        });
    }

    static delete(calendarId, id) {
        const url = `${daysApiRoutes.delete}${calendarId}/${id}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }
}
